import React from 'react'
import { Checkout, actions } from './.'
import { connect } from 'react-redux'
import { actions as cartActions } from '../Cart'
import { actions as addressActions } from '../Address'

const mapStateToProps = ({
  checkout,
  participant,
  cart,
  address,
  balance,
  cardBrands,
  catalog,
  onlyCash,
  oidc,
  shipping
}) => ({
  ...checkout,
  participant,
  cart,
  address,
  balance,
  brands: cardBrands.brands,
  catalog,
  onlyCash,
  oidc,
  shipping
})

const mapDispatchToProps = dispatch => ({
  fetchShipping: zipCode => {
    dispatch(cartActions.fetchShipping(zipCode))
    dispatch(addressActions.fetchAddress(zipCode))
  },
  fetchPointsCashConfig: () => dispatch(actions.fetchPointsCashConfig()),
  fetchInstallments: data => dispatch(actions.fetchInstallments(data)),
  updateShippingAddress: data =>
    dispatch(cartActions.updateShippingAddress(data)),
  createPurchase: creditCardPayment =>
    dispatch(actions.createPurchase(creditCardPayment)),
  redirectConfirmation: orderId => {
    dispatch(actions.redirectConfirmation(orderId))
  },
  closeModal: () => dispatch({ type: 'CLOSE_MODAL' }),
  clearConfirmedOrderData: () =>
    dispatch({ type: 'CLEAR_CONFIRMED_ORDER_DATA' }),
  changePropToSuccess: () => dispatch({ type: 'SUCCESS' }),
  clearError: () => dispatch({ type: 'CLEAR_PURCHASE_ERROR' }),
  loadCart: () => dispatch(cartActions.loadCart()),
  updateShippingEmail: email =>
    dispatch(cartActions.updateShippingEmail(email)),
  removeCoupon: () => dispatch(cartActions.removeCoupon()),
  fetchCashOnlyConfig: () => dispatch(actions.fetchCashOnlyConfig()),
  authorizeWithToken: (
    OrderId,
    PaymentMoneyRequest,
    Token,
    TokenType,
    Resend
  ) =>
    dispatch(
      actions.authorizeWithToken(
        OrderId,
        PaymentMoneyRequest,
        Token,
        TokenType,
        Resend
      )
    ),
  authorizeWithTokenResend: (
    OrderId,
    PaymentMoneyRequest,
    Token,
    TokenType,
    Resend
  ) =>
    dispatch(
      actions.authorizeWithTokenResend(
        OrderId,
        PaymentMoneyRequest,
        Token,
        TokenType,
        Resend
      )
    ),
  authorizeWithTokenLastTry: (
    OrderId,
    PaymentMoneyRequest,
    Token,
    TokenType,
    Resend
  ) =>
    dispatch(
      actions.authorizeWithTokenLastTry(
        OrderId,
        PaymentMoneyRequest,
        Token,
        TokenType,
        Resend
      )
    )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(props => <Checkout {...props} />)



// WEBPACK FOOTER //
// ./src/features/Checkout/CheckoutContainer.js